import React from "react";
import useHideShowDropDown from "../../helpers/hideshowdropdown";

function StatusDropDown({
  options,
  state,
  refs,
  hideDropdown,
  selectStatusChange,
  currentStatusId,
  isChangingCategory,
}) {
  useHideShowDropDown(refs, () => {
    hideDropdown();
  });
  return (
    <ul
      className={`dropdown-menu inner show ${
        options.length > 7 ? "moreopt" : "autoclassstatus"
      }`}
      role="presentation"
      ref={refs}
      style={{ cursor: `${isChangingCategory ? "not-allowed" : "pointer"}` }}
    >
      {" "}
      {options?.map(
        (item, index) =>
          (currentStatusId._id || currentStatusId.id)  !== (item._id || item.id) && (
            <li
              className={`${item._id || item.id === state._id || state.id ? "selected active" : ""}`}
              onClick={() => selectStatusChange(item)}
              key={index}
            >
              <a
                role="option"
                className={`dropdown-item ${
                  (item._id || item.id) === (state._id || state.id) ? "selected active" : ""
                }d`}
              >
                <span class="text">{item.name}</span>
              </a>
            </li>
          )
      )}
    </ul>
  );
}

export default StatusDropDown;
